module.exports = __webpack_public_path__ + "static/media/astronomy.0a82409f.jpg";